(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7054],{

/***/ 38004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Services; }
/* harmony export */ });
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_ItemGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var components_cards_CategoryCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22573);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57731);
/* harmony import */ var lib_features_productSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21475);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);











var PlainCategory = function PlainCategory(props) {
  var category = props.data;
  return _jsx(Link, {
    href: "/services/listing?categories=".concat(category.slug),
    children: _jsx("a", {
      children: _jsx("div", {
        children: category.name
      })
    })
  });
};

var __N_SSP = true;
function Services(props) {
  var _categories = props.categories;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    console.log('service categories: ', JSON.stringify(_categories));
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_blocks_ItemGrid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: t('home:product_browsebycategory'),
        items: _categories,
        render: function render(item) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_cards_CategoryCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            t: t,
            cardType: 'service',
            categoryLevel: 1,
            data: item,
            baseUrl: "/services/listing?categories=".concat(item.slug)
          }, item.slug);
        }
      })
    })
  });
}

Services.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 55325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services",
      function () {
        return __webpack_require__(38004);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3714,4909,7607,5531,9774,2888,179], function() { return __webpack_exec__(55325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);